"use client";

import { cn } from "@/lib/utils";
import Animation from "../ui/animation";
import { Button } from "../ui/button";
import { Typography } from "../ui/typography";

const Bottom = ({ className }: { className?: string }) => {
  return (
    <Animation className={cn("flex w-full px-8 mb-32", className)}>
      <div className="relative flex flex-col gap-5 w-full rounded-3xl overflow-hidden bg-gray-800 p-14 md:py-28 max-w-7xl">
        {/* Background Video */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/video/bottom.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay (optional, soft background tint) */}
        <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-10" />

        {/* Foreground Content */}
        <div className="relative z-20 flex flex-col gap-5">
          <Typography variant="title" className="!text-white">
            Create your own
          </Typography>
          <Typography className="!text-white lg:!text-2xl">
            Заавал 18 нас хүрсэн байх хэрэгтэй эрх зүйн бүрэн чадамжгүй буюу
            18-аас доош настай бол боломжгүй.
          </Typography>
          <Button 
            className="w-fit font-bold sm:px-32 py-6"
            onClick={() => window.open('https://my.motforex.com/auth?tab=signup&contractNo=2220278200', '_blank')}>
            <div className="w-2 h-2 rounded-full bg-white mr-2" />
            Яг одоо эхлэх
          </Button>
        </div>
      </div>
    </Animation>
  );
};

export default Bottom;
